import React from 'react'
import "./common.scss"
import { AddIcon, VisibilityIcon, VisibilityOffIcon } from '../../../../utils/icons';
import CommonModal from "../../../../Components/Modals/index";
import Dropdown from '../../../../Components/Dropdown';

const CommonField = ({ rows,
  handleAddClick = () => { },
  hanldeInputAddition = () => { },
  handleConfirmAction = () => { },
  modal = false,
  modalText={},
  setModalData,
  handleOpen = () => { },
  contClick = () => { } }) => {

  const renderField = (itm) => {
    switch (itm.fieldType) {
      case "alphabet":
        return (
          <div>
            <input type="text" placeholder={itm.place} disabled />
          </div>
        );
      case "numeric":
        return (
          <div>
            <input type="number" placeholder={itm.place} disabled />
          </div>
        );
      case "date":
        return (
          <div>
            <input type='text' placeholder='mm-dd-yyyy' disabled />
          </div>
        );
      case "dropdown":
        return (
          <div>
            <Dropdown
              // label={"Field Type"}
              options={["1", "2"]}
              // value={input}
              // onChange={(e) => handleChange(e)}
              placeholder={itm.place}
              isInput={true}
              isDisabled={true}
            //  isError={validation.status.length}
            //  errorMessage = {validation.status}
            />
          </div>
        );
      case "boolean":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "12px", color: "#ccc" }}>
              <input type="radio" id="yes" name="booleanField" value="yes" />
              Yes
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "12px", color: "#ccc" }}>
              <input type="radio" id="no" name="booleanField" value="no" />
              No
            </label>
          </div>
        );
      default:
        return null; // Or some fallback UI if needed
    }
  };


  return (
    <div className='inpCommFieldSection'>
      <div className='contentForm'>
        {rows.map((itm, ind) => {
          console.log("ITM", itm)
          if (itm?.isClicked && !itm?.isRequired) {
            return (
              <div key={ind} className="contentAfterClick" onClick={() => handleAddClick(itm, ind)}>
                <div className="contentClick">
                  <div>{itm.label}</div>
                  <div>
                    <input type="text" placeholder={itm.place} disabled />
                  </div>
                </div>
                <div className="delEdit" >
                  <div
                    style={{
                      paddingTop: "4px",
                      color: itm.back ? "#333333" : "#EC221F",
                      cursor: "pointer"
                    }}
                    onClick={() => handleOpen(itm, ind)}
                  >
                    {itm.back ?
                      (itm.visible ? <VisibilityIcon style={{ height: "17px", width: "17px" }} /> : <VisibilityOffIcon style={{ height: "17px", width: "17px" }} />) :
                      <img
                        src="/assets/images/red.svg"
                        alt="Delete icon"
                        style={{ height: "15px", width: "15px" }}
                      />
                    }
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                key={ind}
                className="contentSection"
                onClick={() => handleAddClick(itm, ind)}
              >
                <div>{`${itm.label} ${itm.isRequired ? "*" : ""}`}</div>
                {renderField(itm)}

              </div>
            );
          }
        })}
      </div>
      <div className='addInpt' onClick={hanldeInputAddition}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><AddIcon sx={{ color: "#003065" }} /></div>
        <div style={{ color: "#003065" }}>Add Input Fields</div>
      </div>

      {/* {modal && (
        <CommonModal
          setIsOpenPopUp={setModalData}
          open={modal}
          // isLoading={isLoading}
          handleDelete={handleConfirmAction}
          item={modalText}
        />
      )} */}

    </div>
  )
}

export default CommonField